import { HttpAuth } from '../../config/Http'

export const actionTypes = {
    INDEX: 'CAMPAIGNS_INDEX',
    CHART: 'CAMPAIGNS_CHART',
    LOADING: 'CAMPAIGNS_LOADING',
    CHANGE: 'CAMPAIGNS_CHANGE',
    SUCCESS: 'CAMPAIGNS_SUCCESS',
    ERROR: 'CAMPAIGNS_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

export const loadingResponse = (payload) => ({
    type: actionTypes.LOADING,
    payload
})

// INDEX

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = (query, isLoadMore) => dispatch => {
    return HttpAuth.get('/campaigns?'+ new URLSearchParams(query))
            .then(res =>  {
                if(typeof res !== 'undefined') {
                    dispatch(indexResponse(res.data, isLoadMore))
                }
            })
}

// ENCERRADAS

export const closedResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const closed = (query, isLoadMore) => dispatch => {
    return HttpAuth.get('/campaigns/closed?'+ new URLSearchParams(query))
            .then(res => typeof res !== 'undefined' && dispatch(closedResponse(res.data, isLoadMore)))
}


// CHART 
export const chartResponse = (payload) => ({
    type: actionTypes.CHART,
    payload
})

export const chartGeneralPeriod = (query) => dispatch => {
    return HttpAuth.post('/campaigns/chart/general/period?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(chartResponse({afiliado: res.data?.afiliado, period: res.data})))
}

export const chartGeneralHourly = (query) => dispatch => {
    return HttpAuth.post('/campaigns/chart/general/hourly?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(chartResponse({hour: res.data})))
}

export const chartPeriod = (query) => dispatch => {
    return HttpAuth.post('/campaigns/chart/period?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(chartResponse({afiliado: res.data?.afiliado, campaign: res.data?.campaign, period: res.data})))
}

export const chartHourly = (query) => dispatch => {
    return HttpAuth.post('/campaigns/chart/hourly?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(chartResponse({campaign: res.data?.campaign, hour: res.data})))
}